export { defaultInternalLogger, defaultInternalLoggerLevel, InternalLoggerLevel } from './const';

export { createInternalLogger } from './createInternalLogger';

export { initializeInternalLogger, internalLogger } from './initialize';

export type { InternalLogger } from './types';



// WEBPACK FOOTER //
// ../../../src/internalLogger/index.ts